<template>
    <section id="main" class="mt-2 mb-2">
        <v-container>
          
            <v-carousel
            cycle
            hide-delimiter-background
            height="auto"
            width="auto"
            :show-arrows="false"
            >
            <v-carousel-item
                v-for="(logoGroup, i) in chunkedLogos"
                :key="i"
                cycle
                autoplay
                interval="1000"
            >
                <v-row
                align="center"
                justify="center"
                no-gutters
                >
                <v-col
                    v-for="(logo, j) in logoGroup"
                    :key="j"
                    cols="3"
                    sm="3"
                    md="3"
                    lg="3"
                    xl="3"
                >
                    <v-img
                    :src="logo"
                    aspect-ratio="1"
                    class="mr-2 ml-2"
                    height="80px"
                    ></v-img>
                </v-col>
                </v-row>
            </v-carousel-item>
            </v-carousel>

        </v-container>
    </section>
</template>

<script setup>
import { computed } from 'vue';


// Array of logo image paths
const logos = [
  require('@/assets/dosm.png'),
  require('@/assets/MM.png'),
  require('@/assets/75tahun.png'),
];

// Computed property for chunking logos
const chunkedLogos = computed(() => {
  const chunkSize = 3;
  return logos.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / chunkSize);

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // Start a new chunk
    }

    resultArray[chunkIndex].push(item);

    return resultArray;
  }, []);
});

</script>

<style scoped>
#main {
  /* background-image: url("~@/assets/bg6.svg"); */
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
}
</style>


